export default __webpack_public_path__ + "962aaa8a0d88fe29813554f0eeaa4b04.png";